// recoilOutside.js
import { useRecoilCallback } from "recoil";

let setRecoilOutside;

export function RecoilExternalSetter() {
  // cria um setter estável que vive além do snapshot
  setRecoilOutside = useRecoilCallback(
    ({ set }) =>
      (atom, value) => {
        set(atom, value);
      },
    []
  );

  return null; // não renderiza nada
}

export { setRecoilOutside };
